export default {
  title: {
    id: 'mergeExportError.title',
    defaultMessage: 'Export failed',
  },
  apology: {
    id: 'mergeExportError.apology',
    defaultMessage: 'Sorry — we could not export the candidate to your ATS.',
  },
  reason: {
    id: 'mergeExportError.reason',
    defaultMessage:
      'This integration works through the external provider Merge, and the error happened on their side. ' +
      'We have already passed the details to their team so they fix it as soon as possible.',
  },
  action: {
    id: 'mergeExportError.action',
    defaultMessage:
      'While the issue is being fixed, save the resume as a pdf/docx file and upload it to your ATS manually. ' +
      'After the next sync with your ATS the candidate will be marked with the «exported» badge here.',
  },
  downloadPdf: {
    id: 'mergeExportError.downloadPdf',
    defaultMessage: 'Download PDF',
  },
  downloadDocx: {
    id: 'mergeExportError.downloadDocx',
    defaultMessage: 'Download DOCX',
  },
  close: {
    id: 'mergeExportError.close',
    defaultMessage: 'Got it',
  },
};
